import React from 'react';
import styles from './style/card.module.css';

const Card = ({ children, elevation, radius }) => (
  <div
    className={styles.card}
    data-elevation={elevation}
    data-radius={radius}
  >
    { children }
  </div>
);

Card.defaultProps = {
  elevation: '',
  radius: 8,
};

export default Card;
